import { render, staticRenderFns } from "./signingMonthPreferentialLists.vue?vue&type=template&id=f66d8d50&"
import script from "./signingMonthPreferentialLists.vue?vue&type=script&lang=js&"
export * from "./signingMonthPreferentialLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports